module.exports = __webpack_public_path__ + "ca6bfd535579fe07caaa889f6b14b495.svg";